import type { BackendEntities } from 'app/lib/betting/betting-entities';

import { URL } from '../../constants';
import type { ServiceConfig } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';

export const getSearchedValue = (
  config: ServiceConfig,
  payload: string,
) => {
  type AdapterProps = { response: BackendEntities };
  const url = `${URL.SITE_SEARCH}?query=${payload}`;
  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
